//@ts-check
import React from 'react';
import Formatter from '../../../formatter';
import getFilePreviewPath from '../../../utils/pathUtil/getFilePreviewPath';
import getFileThumbnailPath from '../../../utils/pathUtil/getFileThumbnailPath';
/**
 * @typedef {object} Data
 * @property {object} File
 * @property {string} Caption
 *
 * @typedef {object} Props
 * @property {Data} data
 * @param {Props} props
 */

var NameFormatter = function NameFormatter(_ref) {
  var data = _ref.data;
  return React.createElement(Formatter.Link, {
    icon: {
      path: data.File.Path
    },
    text: data.Caption,
    value: getFilePreviewPath({
      workspace: data.File.Workspace,
      path: data.File.Path
    })
  });
};
/** @param {Props} props */


var LastModifiedFormatter = function LastModifiedFormatter(_ref2) {
  var data = _ref2.data;
  return React.createElement(Formatter.DateTime, {
    value: data.File.DateModified
  });
};
/** @param {Props} props*/


var SizeFormatter = function SizeFormatter(_ref3) {
  var data = _ref3.data;
  return React.createElement(Formatter.Text, {
    value: data.File.Length
  });
};

var PROJECT_DEPENDENCIES_DATA_TYPE = {
  columns: [{
    id: 'Caption',
    formatter: NameFormatter,
    serverSort: true
  }, {
    id: 'LastModifiedUTC',
    children: 'Last Modified',
    formatter: LastModifiedFormatter,
    serverSort: true
  }, {
    id: 'Size',
    formatter: SizeFormatter,
    serverSort: true
  }],
  thumbnail: {
    url: function url(data) {
      return getFileThumbnailPath({
        path: data.Previews[0].Path,
        workspace: data.Previews[0].Workspace,
        token: data.Previews[0].ResourceToken
      });
    },
    text: function text(data) {
      return data.Caption;
    },
    icon: function icon(data) {
      return {
        path: data.File.Path
      };
    }
  },
  data: {
    url: '/backend/projectDependencies?name={projectName}',
    dataKey: 'projectDependencies',
    idKeyProp: 'File.Path',
    onBeforeRequest: function onBeforeRequest(_ref4, request) {
      var projectName = _ref4.dataProps.projectName;
      return {
        url: request.url.replace('{projectName}', projectName)
      };
    }
  }
};
export default PROJECT_DEPENDENCIES_DATA_TYPE;